import { render } from "./PaymentCallback.vue?vue&type=template&id=09db4d87&scoped=true"
import script from "./PaymentCallback.vue?vue&type=script&lang=js"
export * from "./PaymentCallback.vue?vue&type=script&lang=js"

import "./PaymentCallback.vue?vue&type=style&index=0&id=09db4d87&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09db4d87"]])

export default __exports__